export enum PacketsClosingType {
  IPEN_WET_INK = 'IPEN_WET_INK',
  IPEN = 'IPEN',
  ELSI = 'ELSI',
}

/** The convidence lever for Unknown documents. Ex: 0.05 . Used in stacking and post prep  */
export const CONFIDENCE_THRESHOLD = 0.1;

export const POST_PREP_PAGE_WIDTH = 168;

export enum PostPrepTab {
  DOCUMENT_TYPES = 'document-types',
  DOCUMENT_GROUPS = 'document-groups',
}
